<script setup lang="ts">import { computed as _computed } from 'vue';



interface Props {
  padding?: [number, number]
}

const props = defineProps<Props>()

const style = _computed(() => {
  if(!props.padding) {
    return {

    }
  }
  return {
    padding: `${props.padding[0]}px ${props.padding[1]}px ${props.padding[0]}px ${props.padding[1]}px`,
  }
})
</script>


<template>
  <div class="full-width-center" :style="style">
    <slot/>
  </div>
</template>

<style scoped lang="scss">
  .full-width-center {
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
</style>
